/* Plume de Vie plan page (reference flow): pick a plan -> Continue -> cart -> Shopify checkout.
   Prices come from the product variants (book = the section's binding + cover, default Souple / Simple),
   so the price on the card is always the price at checkout. The quiz answers (pdv_quiz_v2) go on the order. */
(function () {
  var C = window.PDV_OFFER;
  var root = document.getElementById('pdvo');
  if (!root || !C) return;

  // Keep the fixed bottom button above Shopify's admin/preview bar (only shown to logged-in staff)
  (function (el) {
    if (!el) return;
    var fit = function () {
      var bar = document.getElementById('PBarNextFrameWrapper');
      el.style.bottom = (bar ? Math.round(bar.getBoundingClientRect().height) : 0) + 'px';
    };
    fit();
    var n = 0, t = setInterval(function () { fit(); if (++n > 20) clearInterval(t); }, 500);
    window.addEventListener('resize', fit);
  })(root.querySelector('.pdvo-foot'));

  var quiz = {};
  try {
    quiz = (JSON.parse(localStorage.getItem('pdv_quiz_v2')) || JSON.parse(localStorage.getItem('pdv_quiz_v1')) || {}).answers || {};
  } catch (e) {}
  var clean = function (s) { return String(s || '').replace(/[<>&"]/g, '').trim(); };

  function euros(cents) {
    var n = cents / 100;
    return (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2).replace('.', ',')) + ' €';
  }
  function variant(o1) {
    for (var i = 0; i < C.variants.length; i++) {
      var v = C.variants[i];
      if (v.o1 === o1 && v.o2 === C.binding && v.o3 === C.cover) return v;
    }
    return null;
  }

  var first = (C.plans.filter(function (p) { return p.selected; })[0] || C.plans[0] || {}).v;
  var sel = first;
  var cards = root.querySelectorAll('.pdvo-plan');

  // the customer's own cover from the quiz (colour + author name), like the reference plan thumbnails
  var cover = C.covers[quiz.cover] || C.covers.green;
  cards.forEach(function (el) {
    var v = variant(el.getAttribute('data-v'));
    var img = el.querySelector('.pdvo-cover img');
    if (img && cover) img.src = cover;
    var nm = el.querySelector('.pdvo-cover__n');
    if (nm) nm.textContent = clean(quiz.name);
    if (!v) { el.hidden = true; return; }
    var months = parseInt(el.getAttribute('data-v'), 10) || 0;
    var em = el.querySelector('.pdvo-price em'), old = Math.round((parseFloat(String(el.getAttribute('data-old') || '').replace(',', '.')) || 0) * 100), sEl = el.querySelector('.pdvo-price .pdvo-old');
    if (old > v.price) {   // same as the reference: crossed old price, red price + Promo, black SAVE badge
      sEl.textContent = euros(old);
      el.querySelector('.pdvo-price b').textContent = euros(v.price) + (C.saleWord ? ' ' + C.saleWord : '');
      em.textContent = (C.saveWord || '🔥ÉCONOMISEZ [montant]').replace('[montant]', euros(old - v.price)).replace('[pourcentage]', Math.round((old - v.price) / old * 100) + ' %');
    } else {
      sEl.remove();
      el.querySelector('.pdvo-price b').textContent = euros(v.price);
      if (months && C.perMonth) em.textContent = C.perMonth.replace('[prix]', euros(Math.round(v.price / months))); else em.remove();
    }
  });

  function render() {
    cards.forEach(function (el) {
      var on = el.getAttribute('data-v') === sel;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var v = variant(sel), f = root.querySelector('.pdvo-fine__t');
    var onCard = root.querySelector('.pdvo-plan.is-on .pdvo-plan__name');
    var sp = root.querySelector('.pdvo-sum__plan'), sb = root.querySelector('.pdvo-sum__price');
    if (sp && onCard) sp.textContent = onCard.textContent;
    if (sb) sb.textContent = v ? euros(v.price) : '';
    if (f) f.innerHTML = v ? C.fine.replace('[prix]', euros(v.price)).replace('[duree]', sel) : '';
  }
  cards.forEach(function (el) {
    var pick = function () { sel = el.getAttribute('data-v'); render(); };
    el.addEventListener('click', pick);
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
  });

  function checkout(btn) {
    var v = variant(sel);
    var err = root.querySelector('.pdvo-err');
    if (!v || !v.available) { err.hidden = false; err.textContent = 'Cette formule n\'est pas disponible pour le moment.'; return; }
    btn.disabled = true;
    var props = {};
    if (clean(quiz.name)) props['Nom sur le livre'] = clean(quiz.name);
    if (quiz.cover) props['_Couleur de couverture'] = quiz.cover;
    if (quiz.why) props['_Motivation'] = quiz.why;
    if (quiz.decade) props['_Décennie'] = quiz.decade;
    if (quiz.chapters) props['_Chapitres'] = [].concat(quiz.chapters).join(', ');
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { var em = clean(quiz.email); window.location.href = '/checkout' + (em && /@/.test(em) ? '?checkout[email]=' + encodeURIComponent(em) : ''); })
      .catch(function () {
        btn.disabled = false;
        err.hidden = false; err.textContent = 'Une erreur est survenue. Merci de réessayer.';
      });
  }
  root.querySelectorAll('.pdvo-go').forEach(function (b) { b.onclick = function () { checkout(b); }; });

  // "Valable jusqu'au" = today + 30 days, like the reference refund badge
  var vd = root.querySelector('.pdvo-valid');
  if (vd) {
    var d = new Date(Date.now() + 30 * 864e5);
    vd.textContent = ' ' + vd.getAttribute('data-label') + ' ' + d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) + '.';
  }
  // "Trusted by thousands" slider: one photo at a time, arrows + dots
  (function () {
    var row = root.querySelector('.pdvo-trust__row'), dots = root.querySelectorAll('.pdvo-trust__dots i');
    if (!row) return;
    var n = row.children.length, i = 0;
    var show = function (k) { i = (k + n) % n; row.style.transform = 'translateX(-' + (i * 100) + '%)'; dots.forEach(function (el, j) { el.classList.toggle('is-on', j === i); }); };
    var l = root.querySelector('.pdvo-trust__nav.is-l'), r = root.querySelector('.pdvo-trust__nav.is-r');
    if (l) l.onclick = function () { show(i - 1); };
    if (r) r.onclick = function () { show(i + 1); };
    if (n < 2) { if (l) l.hidden = true; if (r) r.hidden = true; }
  })();

  render();
})();
